/**
 * Created by PhpStorm on 08.05.2017.
 * Author: Shabalin Pavel
 * Email: aisamiery@gmail.com
 */
require('./subclub.module');
require('./controllers/edit.controller');